var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TopNav"),
      _c("div", { staticClass: "auth-wrapper" }, [
        _c(
          "div",
          { staticClass: "auth-wrapper__inner" },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }